export default __webpack_public_path__ + "static/media/skydancer.b10eb4d5.png";